<template>
  <form class="phone-appointment-view" @submit.prevent="onSubmit">

    <div class="mb-3">
      <router-link to="/">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
        {{ $t('navigation.back') }}
      </router-link>
    </div>

    <p class="text-primary small">{{ $t('phone_appointment.info') }}</p>

    <form-radio
        v-if="locationOptions.length > 1"

        class="tag my-4"
        required
        :options="locationOptions"

        v-model="form.id"
    />

    <loading-overlay v-if="pending"/>

  </form>
</template>

<script>
import {mapActions, mapState} from 'vuex';

import FormInput      from 'pixelstein-vue-app-package/src/vue2/PsForm/PsFormInput';
import FormRadio      from 'pixelstein-vue-app-package/src/vue2/PsForm/PsFormRadio';
import FormTextarea   from 'pixelstein-vue-app-package/src/vue2/PsForm/PsFormTextarea';
import LoadingOverlay from '@/components/LoadingOverlay';

export default {
  name: 'PhoneAppointmentView',
  components: {
    LoadingOverlay,
    FormInput,
    FormRadio,
    FormTextarea,
  },
  data() {
    return {
      pending: false,
      form: {},
    };
  },
  computed: {
    ...mapState({
      locations: state => state.Api.Locations.all,
    }),
    selectedLocation() {
      return this.locations.find(({id}) => id === this.form?.id);
    },
    locationOptions() {
      return this.locations.map(({id, name, phone}) => ({
        label: `<span class="font-weight-bold">${name}</span><br><span class="">${phone}</span>`,
        value: id,
      }));
    },
  },
  methods: {
    ...mapActions({
      contact: 'Api/Locations/contact',
    }),
    async onSubmit() {
      if (this.pending) {
        return;
      }

      this.pending = true;

      if (this.locationOptions.length === 1) {
        this.form.id = this.locationOptions?.[0]?.value;
      }

      try {
        await this.contact(this.form);

        this.$router
            .push('/phone-appointment/thank-you')
            .catch(alert);

      } catch (e) {
        this.$apiErrorHandler(e);
      }

      this.pending = false;

    },
  },
};
</script>
